function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IzoomIn = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99991 11.0001C4.99991 7.6911 7.69091 5.0001 10.9999 5.0001C14.3089 5.0001 16.9999 7.6911 16.9999 11.0001C16.9999 14.3091 14.3089 17.0001 10.9999 17.0001C7.69091 17.0001 4.99991 14.3091 4.99991 11.0001ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "3",
    width: "19",
    height: "18"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99991 11.0001C4.99991 7.6911 7.69091 5.0001 10.9999 5.0001C14.3089 5.0001 16.9999 7.6911 16.9999 11.0001C16.9999 14.3091 14.3089 17.0001 10.9999 17.0001C7.69091 17.0001 4.99991 14.3091 4.99991 11.0001ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3677 8.35169C10.3677 7.97537 10.6634 7.67969 11.0397 7.67969C11.416 7.67969 11.7117 7.97537 11.7117 8.35169V10.3677H13.7277C14.104 10.3677 14.3997 10.6634 14.3997 11.0397C14.3997 11.416 14.104 11.7117 13.7277 11.7117H11.7117V13.7277C11.7117 14.104 11.416 14.3997 11.0397 14.3997C10.6634 14.3997 10.3677 14.104 10.3677 13.7277V11.7117H8.35169C7.97537 11.7117 7.67969 11.416 7.67969 11.0397C7.67969 10.6634 7.97537 10.3677 8.35169 10.3677H10.3677V8.35169Z",
    fill: "#495057"
  }));
});